/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.querySelector('.thb-quick-search');
    // 2026-09-09 (port z PL/EU): z jednego uchwytu na LISTE. Nakladke otwiera i lupa
    // desktopowa (id quick-search), i mobilne pole szukania w drugim rzedzie naglowka.
    // Nie moga dzielic id (dwa identyczne id to blad, a JS wiazalby sie tylko z pierwszym),
    // dlatego wspolny atrybut data-quick-search-toggle. Dodajac kolejne miejsce otwierania
    // szukania wystarczy dodac ten atrybut.
    this.buttons = Array.from(document.querySelectorAll('[data-quick-search-toggle]'));
    this.close_button = this.container.querySelector('.thb-search-close');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.container.querySelector('.thb-quick-search--results');

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.container.querySelector('form.searchform');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        var _this = this;
        event.preventDefault();
        document.querySelector('.header-section').classList.toggle('search-open');

        if (document.querySelector('.header-section').classList.contains('search-open')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });

    // Close.
    this.close_button.addEventListener('click', (event) => {
      this.close();
      event.preventDefault();
    });
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') {
        this.close();
      }
    });
  }

  categoryToggle() {
    this.category_toggle = this.container.querySelectorAll('.search-categories a');

    this.category_toggle.forEach((link) => {
      link.addEventListener('click', (event) => {
        [].forEach.call(this.category_toggle, function (el) {
          el.classList.remove('active');
        });
        link.classList.add('active');
        let target = link.getAttribute('href');
        this.container.querySelectorAll('.search-results').forEach((section) => {
          section.classList.remove('active');
        });
        this.container.querySelector(target).classList.add('active');

        event.preventDefault();
      });
    });

  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.predictiveSearchResults.classList.remove('active');
      return;
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,article,query,page&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[limit_scope]')}=each&resources[options][fields]=title,product_type,vendor,variants.title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    this.predictiveSearchResults.classList.add('active');

    this.categoryToggle();
  }

  open() {
    document.querySelector('.header-section').classList.add('search-open');
  }

  close() {
    document.querySelector('.header-section').classList.remove('search-open');
  }
}
// 2026-09-09 (port z PL/EU, fix szybkiego klika): inicjalizacja od razu przy wykonaniu
// skryptu (skrypt ma defer, wiec DOM jest sparsowany), nie dopiero na window.load - czekanie
// na WSZYSTKIE zasoby strony to na wolnym laczu dlugie sekundy, w ktorych klik w wyszukiwarke
// nawigowal na /search zamiast otwierac szuflade. Flaga __swQuickSearchReady i realizacja
// zapamietanego klika wspolpracuja z wczesnym guardem w sections/header.liquid.
const initPredictiveSearch = () => {
  if (window.__swQuickSearchReady || typeof PredictiveSearch === 'undefined') {
    return;
  }
  new PredictiveSearch();
  window.__swQuickSearchReady = true;
  if (window.__swQuickSearchPendingOpen) {
    window.__swQuickSearchPendingOpen = false;
    const btn = document.querySelector('[data-quick-search-toggle]');
    if (btn) {
      btn.click();
    }
  }
};
initPredictiveSearch();
// siatka bezpieczenstwa: gdyby skrypt zostal kiedys zaladowany bez defer, przed DOM
window.addEventListener('load', initPredictiveSearch);